(() => {
  const form = document.querySelector('.ss-newsletter-form form');
  if (!form) return;
  if (form) form.noValidate = true;

  const emailInput = form.querySelector('input[type="email"]');

  const errorDiv = document.querySelector('.mm-error-grp');
  if (!emailInput || !errorDiv) return;

  const errorMsg = errorDiv.querySelector('.error-message');
  if (!errorMsg) return;

  function validateEmail() {
    errorDiv.style.display = 'block';
    const value = emailInput.value.trim();
    errorMsg.textContent = '';

    if (!value) {
      errorMsg.textContent = 'Please enter your email address.';
      return false;
    }

    const atCount = (value.match(/@/g) || []).length;
    if (atCount !== 1) {
      errorMsg.textContent = 'An email address must contain a single @';
      return false;
    }

    if (!emailInput.validity.valid) {
      if (emailInput.validity.typeMismatch) {
        errorMsg.textContent = 'Please enter a valid email address.';
      } else {
        errorMsg.textContent = 'Invalid email address.';
      }
      return false;
    }

    errorMsg.textContent = '';
    errorDiv.style.display = 'none';
    return true;
  }

  form.addEventListener('submit', function (event) {
    if (!validateEmail()) {
      event.preventDefault();
    }
  });

  emailInput.addEventListener('input', validateEmail);
})();
